<template>
    <div class="container">
        <div class="head">
            <maijia-head></maijia-head>
            <div class="flex_column">
                <p>{{$t('maijia.headText0')}}</p>
                <p>『{{$t('maijia.headText1')}}』</p>
                <p>{{$t('maijia.headText2')}}</p>
                <p >{{$t('maijia.headText3')}}</p>
                <p>『{{$t('maijia.headText4')}}』</p>
                <p>{{$t('maijia.headText5')}}<br />
                    {{$t('maijia.headText6')}}</p>
                <div></div>
            </div>
        </div>

        <div class="serve flex_column">
            <p>{{$t('maijia.serveTitle')}}</p>
            <p>{{$t('maijia.serveIllustrate')}}</p>
            <div class="flex_row">
                <div @click="handleServeClick">
                    <div class="serve_shadom" v-show="checkServeIndex==0"></div>
                    <span>{{$t('maijia.serveTitle1')}}</span>
                </div>
                <div @click="handleServeClick">
                    <div class="serve_shadom" v-show="checkServeIndex==1"></div>
                    <span>{{$t('maijia.serveTitle2')}}</span>
                </div>
                <div @click="handleServeClick">
                    <div class="serve_shadom" v-show="checkServeIndex==2"></div>
                    <span>{{$t('maijia.serveTitle3')}}</span>
                </div>
                <div @click="handleServeClick">
                    <div class="serve_shadom" v-show="checkServeIndex==3"></div>
                    <span>{{$t('maijia.serveTitle4')}}</span>
                </div>
                <div @click="handleServeClick">
                    <div class="serve_shadom" v-show="checkServeIndex==4"></div>
                    <span>{{$t('maijia.serveTitle5')}}</span>
                </div>
            </div>
            <div>
                <p>{{serveList[checkServeIndex].name}}</p>
                <p>{{serveList[checkServeIndex].detail}}</p>
            </div>
        </div>
        <div class="case">
            <p>{{$t('maijia.goodCase')}}</p>
            <div class="card_swipe_wrap" @touchstart="handleCaseSwipeTouchStart" @touchend="handleCaseSwipeTouchEnd">
                <div class="card_swipe_item" @click="go('MaiJiaCaseDetail',caseList[0].NewsID,1)" :class="{'act':actIndex==1}" :style="{'left':firstLeft+'rem'}">
                    <img :src="caseList.length>0?caseList[0].Cover:''" alt="">
                    <p>{{caseList.length>0?caseList[0].Title:''}}</p>
                    <p>{{caseList.length>0?caseList[0].Summary:''}}</p>
                </div>
                <div class="card_swipe_item" @click="go('MaiJiaCaseDetail',caseList[1].NewsID,2)" :class="{'act':actIndex==2}" :style="{'left':secondLeft+'rem'}">
                    <img :src="caseList.length>0?caseList[1].Cover:''" alt="">
                    <p>{{caseList.length>0?caseList[1].Title:''}}</p>
                    <p>{{caseList.length>0?caseList[1].Summary:''}}</p>
                </div>
                <div class="card_swipe_item" @click="go('MaiJiaCaseDetail',caseList[2].NewsID,3)" :class="{'act':actIndex==3}" :style="{'left':thirdLeft+'rem'}">
                    <img :src="caseList.length>0?caseList[2].Cover:''" alt="">
                    <p>{{caseList.length>0?caseList[2].Title:''}}</p>
                    <p>{{caseList.length>0?caseList[2].Summary:''}}</p>
                </div>
            </div>
            <div class="case_more_btn" @click="go('MaiJiaCaseList')">
                <span>{{$t('maijia.seeMore')}}</span>
                <img src="../assets/images/maijia_arrow_right.png" />
            </div>
        </div>

        <div class="maijia">
            <p>{{$t('maijia.maijiaTitle')}}</p>
            <p>{{$t('maijia.maijiaText1')}}</p>
            <p>{{$t('maijia.maijiaText2')}}</p>
            <p>{{$t('maijia.maijiaText3')}}</p>
        </div>

        <div class="contact">
            <div>
                <p>{{$t('maijia.contactTitle')}}</p>
                <p>{{$t('maijia.contactIllustrate')}}</p>
                <input type="text" v-model="name" :placeholder="placeholderName">
                <input type="text" v-model="contactWay" :placeholder="placeholderContactWay">
                <div @click="handleSubmit">{{$t('maijia.submitBtn')}}</div>
            </div>
        </div>

        <div class="partner">
            <p>{{$t('maijia.partnersTitle')}}</p>
            <van-swipe :autoplay="3000" indicator-color="#FF6D27" :height="130.5">
                <van-swipe-item>
                    <img class='swipe_img' src="../assets/images/maijia_partner1_xinjiang.png" alt="">
                </van-swipe-item>
                <van-swipe-item>
                    <img class='swipe_img' src="../assets/images/maijia_partner2_xinjiang.png" alt="">
                </van-swipe-item>
                <van-swipe-item>
                    <img class='swipe_img' src="../assets/images/maijia_partner3.png" alt="">
                </van-swipe-item>
                <van-swipe-item>
                    <img class='swipe_img' src="../assets/images/maijia_partner4.png" alt="">
                </van-swipe-item>
            </van-swipe>
        </div>

        <div class="address flex_row">
            <div>
                <div>
                    <span :class="{'spanEn':$i18n.locale=='en'}">{{$t('maijia.contactAdressTitle')}}</span>
                    <span>{{$t('maijia.contactAdressDetail')}}</span>
                </div>
                <div>
                    <span :class="{'spanEn':$i18n.locale=='en'}">{{$t('maijia.contactTelTitle')}}</span>
                    <span>{{$t('maijia.contactTelDetail')}}</span>
                </div>
                <div>
                    <span :class="{'spanEn':$i18n.locale=='en'}">{{$t('maijia.contactEmailTitle')}}</span>
                    <span>{{$t('maijia.contactEmailDetail')}}</span>
                </div>
                <img src="../assets/images/maijia_erweima.png" alt="">
                <p>{{$t('maijia.contactText6')}}</p>
            </div>
            <div>
                <el-amap vid="amapDemo" :zoom="zoom" :center="center">
                    <el-amap-info-window :position="mywindow.position" :content="mywindow.content" :visible="mywindow.visible" :events="mywindow.events"></el-amap-info-window>
                    <el-amap-marker :position="marker.position" :events="marker.events" :visible="marker.visible" :draggable="marker.draggable"></el-amap-marker>
                </el-amap>
            </div>
        </div>
        <common-footer></common-footer>
    </div>
</template>

<script>
import maijiaHead from '../components/maijia-head.vue'
import commonFooter from '../components/common-footer.vue'
export default {
    data() {
        return {
            checkServeIndex: '',
            serveList: [],
            actIndex: 2,
            firstLeft: null,
            secondLeft: null,
            thirdLeft: null,
            caseList: [],
            name: '',
            contactWay: '',
            placeholderName: '',
            placeholderContactWay: '',
            zoom: 14,
            center: [120.25188, 30.31858],
            marker: {
                position: [120.25188, 30.31858],
                visible: true,
                draggable: true
            },
            mywindow: {
                position: [120.25188, 30.31858],
                content: '<div style="font-size:13px;">东谷创业园</div>',
                visible: true
            },
            plugin: {
                pName: "Scale",
                events: {
                    init(instance) {
                        console.log(instance);
                    }
                }
            }
        }
    },
    components: {
        maijiaHead,
        commonFooter
    },
    computed: {
        lang() {
            return this.$i18n.locale
        }
    },
    watch: {
        'lang'() {
            const { handleLangChange } = this
            handleLangChange()
        }
    },
    created() {
        const { handleLangChange } = this
        handleLangChange()
        this.fontSize = parseFloat(document.querySelector('html').style.fontSize)
        this.firstLeft = -(85.5 / this.fontSize)
        this.secondLeft = 85.5 / this.fontSize
        this.thirdLeft = 259.5 / this.fontSize
    },
    methods: {
        go(name, NewsID, i) {
            //详情
            if (name == 'MaiJiaCaseDetail') {
                if (i == this.actIndex) {
                    this.$router.push({ name, query: { NewsID } })
                }
            } else {
                //列表
                this.$router.push({ name })
            }
        },

        getData() {
            this.$http.get("/site/mplus-case", {
                params: {
                    lang: this.$i18n.locale,
                    Page: 1,
                    Pagesize: 3
                }
            }).then(response => {
                this.caseList = response.d.Results
            });
        },
        handleLangChange() {
            const { handleServeList } = this
            if (this.$i18n.locale == 'en') {
                this.placeholderName = 'your name'
                this.placeholderContactWay = 'contact information'
            } else {
                this.placeholderName = '您的姓名'
                this.placeholderContactWay = '您的联系方式'
            }
            handleServeList()
        },
        handleServeList() {
            const { getData } = this
            getData()
            this.serveList = [
                { name: this.$t('maijia.serveTitle1'), detail: this.$t('maijia.serveDetail1') },
                { name: this.$t('maijia.serveTitle2'), detail: this.$t('maijia.serveDetail2') },
                { name: this.$t('maijia.serveTitle3'), detail: this.$t('maijia.serveDetail3') },
                { name: this.$t('maijia.serveTitle4'), detail: this.$t('maijia.serveDetail4') },
                { name: this.$t('maijia.serveTitle5'), detail: this.$t('maijia.serveDetail5') },
            ]
            this.checkServeIndex = 0
            this.checkServeName = this.serveList[0].name
            this.checkServeDetail = this.serveList[0].detail
        },
        handleServeClick(e) {
            const { serveList } = this
            serveList.find((v, i) => {
                if (v.name == e.target.innerText) {
                    this.checkServeIndex = i
                }
            })
        },
        handleCaseSwipeTouchStart(e) {
            this.startX = e.changedTouches[0].pageX
        },
        handleCaseSwipeTouchEnd(e) {
            if (this.startX > e.changedTouches[0].pageX) {
                this.actIndex = this.actIndex == 3 ? 1 : ++this.actIndex;
            } else if (this.startX < e.changedTouches[0].pageX) {
                this.actIndex = this.actIndex == 1 ? 3 : --this.actIndex
            }
            this.firstLeft = this.actIndex == 1 ? 85.5 / this.fontSize : this.actIndex == 2 ? -(85.5 / this.fontSize) : 259.5 / this.fontSize
            this.secondLeft = this.actIndex == 1 ? 259.5 / this.fontSize : this.actIndex == 2 ? 85.5 / this.fontSize : -(85.5 / this.fontSize)
            this.thirdLeft = this.actIndex == 1 ? -(85.5 / this.fontSize) : this.actIndex == 2 ? 259.5 / this.fontSize : 85.5 / this.fontSize
        },
        handleSubmit() {
            const { name, contactWay } = this
            if (!name || !contactWay) return
            this.$http.get("site/mplus-customer", {
                params: {
                    Name: name,
                    Email: contactWay
                }
            }).then(response => {
                if (response.f > 0) {
                    this.$message.success('提交成功！')
                } else {
                    this.$message.error(response.m)
                }
            });
        }
    }
}
</script>

<style lang="less" scoped>
.flex_column {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.flex_row {
    display: flex;
    flex-wrap: wrap;
}

.container {
    background-color: #fafafa;
}
.head {
    background: url("../assets/images/mj_banner_h5.png");
    background-size: cover;
    background-repeat: no-repeat;
    & > div:nth-child(2) {
        padding-top: 10px;
        padding-bottom: 17px;
        & > p {
            width: 321px;
            text-align: center;
            word-break: normal;
        }
        & > p:nth-child(1) {
            font-size: 18px;
            color: #ffffff;
        }
        & > p:nth-child(2),
        & > p:nth-child(5) {
            font-size: 12px;
            color: #ff6d27;
            padding: 11px 0 6.5px;
        }
        & > p:nth-child(3),
        & > p:nth-child(4),
        & > p:nth-child(6) {
            font-size: 11px;
            color: #ffffff;
            text-align: center;
        }
        & > div:nth-child(7) {
            width: 11px;
            height: 11px;
            border-top: 2px solid #fff;
            border-right: 2px solid #fff;
            transform: rotate(135deg);
            margin-top: 19.7px;
        }
    }
}

.serve {
    padding: 20px 16px;
    & > p:nth-child(1) {
        font-size: 16px;
        color: #000000;
    }
    & > p:nth-child(2) {
        font-size: 11px;
        color: #666666;
        padding: 4px 0 16px;
        word-break: normal;
    }
    & > div:nth-child(3) {
        margin-bottom: 12px;
        & > div {
            height: 56px;
            font-size: 14px;
            color: #ffffff;
            background-repeat: no-repeat;
            background-size: cover;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            & .serve_shadom {
                width: 100%;
                height: 100%;
                background-color: #000;
                opacity: 0.9;
                position: absolute;
            }
            & > span {
                z-index: 100;
            }
        }
        & > div:nth-child(1) {
            width: 167.5px;
            margin-right: 8px;
            margin-bottom: 8px;
            background-image: url("../assets/images/maijia_serve1.png");
        }
        & > div:nth-child(2) {
            width: 167.5px;
            margin-bottom: 8px;
            background-image: url("../assets/images/maijia_serve2.png");
        }
        & > div:nth-child(3) {
            width: 167.5px;
            margin-right: 8px;
            margin-bottom: 8px;
            background-image: url("../assets/images/maijia_serve3.png");
        }
        & > div:nth-child(4) {
            width: 167.5px;
            margin-bottom: 8px;
            background-image: url("../assets/images/maijia_serve4.png");
        }
        & > div:nth-child(5) {
            width: 343px;
            background-image: url("../assets/images/maijia_serve5.png");
        }
    }
    & > div:nth-child(4) {
        & > p:nth-child(1) {
            font-size: 16px;
            color: #333333;
            padding-bottom: 8px;
        }
        & > p:nth-child(2) {
            font-size: 12px;
            color: #333333;
            line-height: 20px;
            word-break: normal;
        }
    }
}

.case {
    padding: 20px 0 12px 0;
    background: #000000;
    display: flex;
    flex-direction: column;
    align-items: center;
    & > p {
        padding-bottom: 20px;
        font-size: 16px;
        color: #ffffff;
    }

    & .card_swipe_wrap {
        width: 100%;
        margin-bottom: 12px;
        position: relative;
        height: 178.5px;
        overflow: hidden;
        & .card_swipe_item {
            width: 204px;
            height: 178.5px;
            position: absolute;
            transition: all 0.3s;
            transform: scale(0.7);
            opacity: 0.8;
            background-color: #2c2c2c;
            padding: 8px 8px 12px 8px;
            box-sizing: border-box;
            & > img {
                width: 188px;
                height: 106px;
                display: block;
            }
            & > p:nth-child(2) {
                font-size: 14px;
                color: #ffffff;
                padding: 12px 0 4px;
            }
            & > p:nth-child(3) {
                font-size: 12px;
                color: #999999;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        & > div.act {
            z-index: 2;
            transform: scaleY(1);
            opacity: 1;
        }
    }

    & .case_more_btn {
        // width: 69px;
        // height: 22px;
        padding:4px 10px;
        border: 1px solid #ffffff;
        color: #fff;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        & img {
            margin-left: 2px;
        }
    }
}

.maijia {
    padding: 20px 16px;

    & > p:nth-child(1) {
        font-size: 16px;
        color: #000000;
        text-align: center;
        padding-bottom: 12px;
    }
    & > p:nth-child(3) {
        padding: 5px 0;
    }
    & > p:nth-child(2),
    & > p:nth-child(3),
    & > p:nth-child(4) {
        font-size: 12px;
        color: #666666;
        line-height: 20px;
    }
}

.contact {
    padding: 16px;
    background-image: url("../assets/images/maijia_bg_contact.png");
    background-size: cover;
    background-repeat: no-repeat;
    & > div {
        background: #ffffff;
        padding: 16px 32.5px;
        box-sizing: border-box;
        & > p:nth-child(1) {
            font-size: 16px;
            color: #333333;
            text-align: center;
        }
        & > p:nth-child(2) {
            font-size: 11px;
            color: #666666;
            text-align: center;
            padding: 4px 0 16px;
            word-break: normal;
        }
        & > input {
            width: 278px;
            height: 36px;
            background: #fafafa;
            border: none;
            padding: 0 12px;
            border-radius: 4px;
            font-size: 14px;
            color: #333333;
            display: block;
        }
        & > input:nth-child(4) {
            margin: 12px 0;
        }

        & > div {
            height: 44px;
            text-align: center;
            line-height: 46px;
            background: #ff6d27;
            border-radius: 4px;
            font-size: 16px;
            color: #ffffff;
        }
    }
}

.partner {
    padding: 20px 16px;

    & > p {
        font-size: 16px;
        color: #020202;
        text-align: center;
        padding-bottom: 20px;
    }

    & .swipe_img {
        width: 342.5px;
        height: 116.5px;
        display: block;
    }
    & .van-swipe-item:last-child > .swipe_img {
        height: 57px;
    }
    & /deep/ .van-swipe__indicators {
        bottom: 0px;
        & .van-swipe__indicator {
            width: 4px;
            height: 4px;
            border: 1px solid #ff6d27;
            box-sizing: border-box;
        }
        & .van-swipe__indicator--active {
            width: 14px;
            border-radius: 4px;
        }
    }
}

.address {
    margin-bottom: 28px;
    & > div {
        width: 50%;
    }
    & > div:nth-child(1) {
        background-color: #000000;
        padding: 16px;
        color: #fff;
        & > div {
            font-size: 11px;
            line-height: 18px;
            display: flex;
            align-items: flex-start;
            span:nth-child(1) {
                width: 38px;
            }
            .spanEn {
                width: 45px !important;
            }
            span:nth-child(2) {
                flex: 1;
            }
        }
        & > div:nth-child(3) {
            margin-bottom: 16px;
        }
        & > img {
            width: 71px;
            height: 71px;
            display: block;
        }
        & > p:nth-child(5) {
            padding-top: 8px;
            font-size: 12px;
            color: #ffffff;
        }
    }
}
</style>